import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

export const initRevealText = () => {
  const revealTextTrigger = document.querySelectorAll('.js-reveal-trigger');
  const revealText = document.querySelectorAll('.js-reveal-text p');

  function createWordElement(word) {
    const wordElem = document.createElement('div');
    wordElem.innerHTML = word;
    wordElem.classList.add('word');
    return wordElem;
  }

  revealText.forEach(text => {
    const childNodes = Array.from(text.childNodes);
    text.innerHTML = '';

    childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.split(/(\s+)/);

        words.forEach(word => {
          if (word.trim() !== '') {
            const wordElem = createWordElement(word.trim());
            text.appendChild(wordElem);
          }
          text.appendChild(document.createTextNode(' '));
        });
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const wrapper = document.createElement('div');
        wrapper.className = 'word';
        wrapper.appendChild(node);
        text.appendChild(wrapper);
      }
    });
  });

  function initTextAnimation() {
    revealTextTrigger.forEach(textBlock => {
      const words = textBlock.querySelectorAll('.word');

      gsap.timeline({
          scrollTrigger: {
            trigger: textBlock,
            start: "top 80%",
            end: "bottom 50%",
            scrub: true,
          },
        })
        .to(words, {
          className: "word active",
          stagger: 0.1,
        });
    });
  }

  return {
    init() {
      initTextAnimation();
    },
  }
}
